import React, { Component } from 'react';

import {
  Typography, withStyles,
} from '@material-ui/core';

const styles = (theme) => {
  return {
    title: {
      fontWeight: 'bold',
    },
    header: {
      backgroundColor: '#583c5c',
      color: 'white',
    },
    details: {
      display: 'flex',
      margin: theme.spacing(1),
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    },
    editButton: {
      float: 'right',
      backgroundColor: 'white',
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginRight: theme.spacing(1.5),
      marginTop: theme.spacing(1.5),
    },
    field: {
      minWidth: '50%',
      textAlign: 'start',
    },
  };
};

class TemplateSummary extends Component {
  render() {
    const { template } = this.props;
    const { classes } = this.props;

    return (
      <div>
        <div className={classes.header}>
          <Typography variant="h6">
            {template.name}
          </Typography>
          <Typography>
            {template.title}
          </Typography>
        </div>
        <div className={classes.details}>
          <Typography className={classes.field}>
            <span className={classes.title}>Type: </span>
            {template.type}
          </Typography>
          <Typography className={classes.field}>
            <span className={classes.title}>Block: </span>
            {template.block ? template.block : 'None'}
          </Typography>
          <Typography className={classes.field}>
            <span className={classes.title}>Time: </span>
            {template.time}
          </Typography>
          <Typography className={classes.field}>
            <span className={classes.title}>Exercises: </span>
            {template.ids.length}
          </Typography>
          <Typography className={classes.field}>
            <span className={classes.title}>Precedings: </span>
            {template.precedings.length}
          </Typography>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(TemplateSummary);
